import React from 'react';
import iconArrowRight from 'assets/images/icon-arrow-right.svg';
import logoMark from 'assets/images/logo-mark.png';

interface ICta {
    href: string
    label: string
}

interface IPageHero {
    eyebrow?: string
    title: React.ReactNode
    lead?: React.ReactNode
    visual?: string
    visualAlt?: string
    visualFit?: 'photo' | 'illustration'
    watermark?: boolean
    watermarkSrc?: string
    primaryCta?: ICta
    secondaryCta?: ICta
}

const PageHero = ({
    eyebrow,
    title,
    lead,
    visual,
    visualAlt,
    visualFit = 'photo',
    watermark,
    watermarkSrc,
    primaryCta,
    secondaryCta
}: IPageHero) => {
    const showWatermark = Boolean(watermark || watermarkSrc);
    const hasVisual = Boolean(visual) || showWatermark;
    const watermarkImage = watermarkSrc || logoMark;

    return (
        <section className={`page-hero${hasVisual ? ' has-visual' : ''}`}>
            <div className="page-hero-blob page-hero-blob-tr" aria-hidden="true" />
            <div className="page-hero-blob page-hero-blob-bl" aria-hidden="true" />
            <div className="container">
                <div className="page-hero-grid">
                    <div className="page-hero-copy">
                        {eyebrow && <p className="page-hero-eyebrow">{eyebrow}</p>}
                        <h1>{title}</h1>
                        {lead && <div className="page-hero-lead">{lead}</div>}
                        {(primaryCta || secondaryCta) && (
                            <div className="page-hero-actions">
                                {primaryCta && (
                                    <a href={primaryCta.href} className="default-btn btn-pop default-transition">
                                        {primaryCta.label}
                                        <img src={iconArrowRight} alt="" />
                                    </a>
                                )}
                                {secondaryCta && (
                                    <a href={secondaryCta.href} className="default-btn btn-ghost default-transition">
                                        {secondaryCta.label}
                                        <img src={iconArrowRight} alt="" />
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                    {hasVisual && (
                        <div className="page-hero-visual">
                            {showWatermark && <img className={`page-hero-watermark${watermarkSrc ? ' is-brand' : ''}`} src={watermarkImage} alt="" />}
                            {visual && (
                                <div className={`page-hero-card${visualFit === 'illustration' ? ' is-illustration' : ''}`}>
                                    <img src={visual} alt={visualAlt || ''} />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default PageHero;
